<template>
  <section
    ref="container"
    v-loading="loading"
    v-copy="''"
    element-loading-text="等待最終支付完成"
    element-loading-spinner="el-icon-loading"
    class="detail-page-container">
    <!--    <div class="top-bar">-->
    <!--      <span>Policy</span>-->
    <!--    </div>-->
    <section class="main-container">
      <div
        class="main-header "
        :class="{'border_bottom':!showMain,'pdb-10':showMain}">
        <div class="flex-sb">
          <div>
            <div class="header-title flex">
              <span
                v-if="merchant_platform"
                class="table-icon__img icon mg-r-15">
                <img :src="getOptionName('serverTypeIcon',merchant_platform)" >
              </span>
              <span
                class="icon"
                :class="{
                  'gray': detailData.effectiveness == 1,
                  'green': detailData.effectiveness == 2,
                  'red': detailData.effectiveness == 3
                }">
                <font-awesome-icon
                  icon="file-powerpoint"
                />
              </span>
              <span
                class="table-icon"
              >
                <span
                  v-tooltip="detailData.company_language"
                  class="icon icon-content"
                >
                  <img
                    :src="getOptionData('companySmallIcon', detailData.company_id).logo? getOptionData('companySmallIcon', detailData.company_id).logo: detailData.company_logo"
                  >
                </span>
              </span>
              <div  class="table-icon">
                <span
                  v-tooltip="detailData.class_language"
                  class=" icon-content"
                >
                  <font-awesome-icon
                    v-if="detailData.class_id&& detailData.product_id!==80||detailData.sme_versions==3"
                    :icon="getOptionName('iconOptions', detailData.class_id)" />
                  <font-awesome-icon
                    v-else
                    icon="cube" />
                </span>
              </div>
              <h3>{{ detailData.company_language }}&nbsp;{{detailData.plan}}</h3>
            </div>
            <div  class="header-title flex">
              <!-- <span class="span-status">
              <font-awesome-icon icon="pen-nib" />
              Incomplete
            </span> -->
              <span
                class="span-status"
                :class="{
                  'red': [801, 0].includes(detailData.pcy_stts),
                  'orange': [401, 301].includes(detailData.pcy_stts),
                  'yellow-dark': [410, 501, 701].includes(detailData.pcy_stts),
                  'blue': [420, 505, 705].includes(detailData.pcy_stts),
                  'green': [425, 510, 710].includes(detailData.pcy_stts)
                }">
                <font-awesome-icon
                  v-if="[425, 510].includes(detailData.pcy_stts)"
                  icon="clipboard-check" />
                <font-awesome-icon
                  v-if="detailData.pcy_stts == 401"
                  icon="pen-nib" />
                <font-awesome-icon
                  v-if="detailData.pcy_stts == 410"
                  icon="check" />
                <font-awesome-icon
                  v-if="[420, 505, 705].includes(detailData.pcy_stts)"
                  icon="print" />
                <font-awesome-icon
                  v-if="detailData.pcy_stts == 801"
                  icon="hourglass-end" />
                <font-awesome-icon
                  v-if="[301, 501, 701].includes(detailData.pcy_stts)"
                  icon="file-invoice-dollar" />
                <font-awesome-icon
                  v-if="detailData.pcy_stts == 0"
                  icon="skull" />
                <font-awesome-icon
                  v-if="[710].includes(detailData.pcy_stts)"
                  icon="calendar-check" />
                {{ detailData.pcy_stts_language }}
              </span>
              <span
                v-for="(v,i) in detailData.tag_language"
                :key="i"
                class="span-options"
                :class="{
                  'gold': v.id == 1,
                  'yellow-dark': v.id == 16384,
                  'blue': [2,16,64,256].includes(v.id),
                  'orange': v.id == 4,
                  'black': [8,32,128].includes(v.id),
                  'red': [512].includes(v.id),
                  'gray': [1024, 2048].includes(v.id),
                  'green': [32768].includes(v.id)
                }"
              >{{v.name}}</span>
              <span class="header-date">Created  <span class="number-color number-fontsize">{{ SmeProduct?detailData.created_at:detailData.sort_time }}</span></span>
              <span class="header-date">Last Updated  <span class="number-color number-fontsize">{{ detailData.updated_at }}</span></span>
              <span
                class="flex flex-align-center mg-r-8">
                <font-awesome-icon
                  v-if="[0,1].includes(detailData.pcy_agreement_1)"
                  icon="square-check"
                  class="mg-r-3 fs-12"
                  :class="{'pending_verify-color':detailData.pcy_agreement_1==0,'verified-color':detailData.pcy_agreement_1==1} "></font-awesome-icon>
                <span
                  class="fs-12"
                  :class="{
                    'pending_verify-color': detailData.pcy_agreement_1 ==0,
                    'verified-color': detailData.pcy_agreement_1 == 1,
                  }">{{ getOptionName('user_agreement_option', detailData.pcy_agreement_1) }}</span>
              </span>
            </div>
            <div class="header-title mg-b-5 flex">
              <span
                v-if="detailData.according_pcy_no&&!isSMEProduct"
                class="hcid">Policy No.  <span class="number-color">{{ detailData.according_pcy_no }}</span></span>
              <span
                v-if="isSMEProduct"
                class="hcid">Policy No.  <span class="number-color">{{ detailData.pcy_no }}</span></span>
              <span
                v-if="detailData.order_sn"
                class="hcid">Ref <span class="number-color">{{ detailData.order_sn }}</span></span>
            </div>
          </div>
          <div class="form-item">
            <span>Assignee</span>
            <span>

              <v-select
                v-model="detailData.cs_id"
                icon="user-nurse"
                :list="assigneeList"
                :clearable="true"
                @change="selectAssignee"
              />
            </span>
          </div>
        </div>
        <el-tabs
          v-if="showMain"
          v-model="activeTab"
          @tab-click="handleChangeLog">
          <el-tab-pane
            v-for="(tab, index) in filterTabList"
            :key="index"
            :label="tab.label"
            :name="String(tab.name)"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div
        v-if="showMain"
        class="main-body">
        <section class="main-content">
          <div class="middle-col">

            <v-serviced-progress
              v-if="merchant_platform"
              class="mg-b-20"
              :agency-name="detailData.agency_name"
              :is-fina="isFina"></v-serviced-progress>
            <section class="status-bar-container">
              <div
                v-if="currentFormData.pcy_stts == 0"
                class="void-status mg-b-20">
                <span>Void</span>
                <span>This policy has been voided.</span>
              </div>
              <div
                v-if="showEndorsementStatusBar && false"
                class="status-bar status-bar-endorsement flex-sb">
                <div class="left">
                  <span>Endrosement Quote</span>
                  <span>This policy has an endorsement quote pending.</span>
                </div>
                <div class="right">
                  <v-button @click="viewTicket">View Support Ticket</v-button>
                </div>
              </div>
              <!-- <div
                v-if="isAdjust"
                class="status-bar status-bar-blue flex-sb">
                <div class="left">
                  <span>Send to Insurer</span>
                  <span>Turn this policy to New Policy if it has been sent to insurer.</span>
                </div>
                <div class="right">
                  <v-button @click="viewTicket">Turn to New Policy</v-button>
                  <v-button
                    v-if="false"
                    :disabled="true"
                    type="primary"
                    plain>Adjustment Payment Pending</v-button>
                </div>
              </div> -->

            </section>
            <section
              v-if="[401, 301].includes(detailData.pcy_stts)&&activeTab == 'Policy'"
              class="pd-b-20">
              <block-warning
                waringTitle="These documents are missing from this policy. They are mandatory for this policy proceed to issuing."
                :list="tabName"
                @click="handleRemindSend"
              >
              </block-warning>
            </section>


            <policy-tab
              v-show="activeTab == 'Policy' || activeTab == 'Documents'"
              :activeTab="activeTab"
              :orderId="orderId"
              :pcyId="pcyId"
              :form="detailData"
              :old-form-data-lock="oldFormDataLock"
              @getCurrentOrderId="getCurrentOrderId"
              @changeCurrentFormData="getCurrentFormData"
              @adjust="handlerAdjustPolicy"
              @tabName="handTabName"
              @update="handler().updatePolicyDetail(0)"
              @loading="hanldeLoading"
            />
            <payment-record
              v-show="activeTab == 'Payment'"
              :records="currentFormData.payment_record" />
            <policy-invoice
              v-show="activeTab == 'Invoice'"
              :stts="detailData.pcy_stts"
              :form="currentFormData"
              :invoice="currentFormData.policy_invoice"
              @update="handler().updatePolicyDetail(0)"
            />
            <tickets-tab
              v-show="activeTab == 'Tickets'"
              :form="currentFormData"
              @update-data="updateTicketsData"
            />
            <claims-tab
              v-show="activeTab == 'Claims'"
              :claims="currentFormData.claims_record" />
            <quotes-tab
              v-show="activeTab == 'Quotes'"
              :quoteData="detailData.renew_quote_list"
              @currentChange="quoteCurrentChange" />
            <the-cheques
              v-show="activeTab == 'Cheques'"
              :cheques="currentFormData.cheques"
              @update="handler().updatePolicyDetail(0)" />
            <detail-log
              v-show="activeTab == 'log'"
              :logsData="logsData">
            </detail-log>
            <api-log  v-show="activeTab == 'ApiLog'"></api-log>
          </div>
          <div class="right-col">
            <aside>
              <!-- 訂單狀態更新 UI -->
              <detail-aside
                :form="detailData"
                :tabName="tabName"
                @viewDocuments="activeTab = 'Documents'"
                @update="handler().updatePolicyDetail(0)"
                @markIssuingSuccess="handlerMarkIssuingSuccess" />
              <div
                v-if="tagArr.includes(1) || tagArr.includes(2)"
                class="box">
                <span class="label mg-b">{{tagArr.includes(1) ? 'Handling' : 'New'}}</span>
                <v-button
                  gray
                  :icon="tagArr.includes(1) ? 'hand-paper' : 'undo'"
                  @click="network().changeTag()"
                >{{tagArr.includes(1) ? 'Make As Handling' : `Make As New  ${isNewSME?'Case':''}`}}</v-button>
              </div>
              <div class="box child-button-block">
                <span class="label mg-b-10">Actions</span>
                <v-button
                  blue
                  icon="plus"
                  @click="openDialog('new-general-ticket')"
                >New General Ticket</v-button>
                <template v-if="!isHzmb">
                  <v-button
                    v-show="showEndorsementTicketBtn && !showEndorsementStatusBar&&!isSMEProduct"
                    blue
                    icon="plus"
                    @click="openDialog('new-endorsement-ticket')"
                  >New Endorsement Ticket</v-button>
                  <v-button
                    v-show="showEndorsementStatusBar"
                    gray
                    @click="viewTicket"
                  >View Endorsement Ticket</v-button>
                  <!-- Endorsement Ready 后 -->
                  <v-button
                    v-if="showViewEndorsement"
                    green
                    icon="eye"
                    @click="onViewEndorsementTicket">View Endorsement Ticket</v-button>
                </template>
                <v-button
                  v-show="showClaimTicketBtn"
                  blue
                  icon="plus"
                  @click="openDialog('new-claim-ticket')"
                >New Claim Ticket</v-button>
                <v-button
                  v-show="showChequeBtn"
                  warning-btn
                  icon="plus"
                  @click="openDialog('create-cheque')"
                >Create Cheque</v-button>
                <v-button
                  v-show="showVoidBtn"
                  red
                  icon="skull"
                  @click="handlerVoidPolicy">Void Policy & Refund</v-button>
                <v-button
                  v-if="!isNewSME"
                  gray
                  icon="copy"
                  @click="onCopyKyc"
                >Copy KYC</v-button>
                <v-button
                  gray
                  icon="copy"
                  @click="handleCopyPolicy(3)">Policyholder Page URL</v-button>
                <v-button
                  v-if="isFina"
                  gray
                  icon="copy"
                  @click="handleCopyPolicy(2)">Referrer Page URL</v-button>
              </div>
              <div class="box child-button-block">
                <span class="label mg-b">Renew Status: <span
                  :class="{
                    'blue': detailData.renew_status === 2,
                    'gold': detailData.renew_status === 3,
                    'red': detailData.renew_status === 4,
                    'orange': detailData.renew_status === 5,
                    'black': detailData.renew_status === 6,
                    'gray': detailData.renew_status === 1,
                    'green': detailData.renew_status === 7
                  }">{{getGlobalOptionName('renew_status',detailData.renew_status)}}</span></span>
                <v-button
                  v-if="!showViewRenewBtn&&renew_ticket_id<=0"
                  blue
                  icon="plus"
                  @click="addRenewQuote">Add Renew Ticket</v-button>
                <v-button
                  v-show="showEditRenewBtn"
                  gray
                  icon="edit"
                  @click="editRenewQuote">
                  Edit Renew Quote
                  <span class="rej">Rejected</span>
                </v-button>
                <v-button
                  v-if="renew_ticket_id>0"
                  green
                  icon="eye"
                  @click="viewRenewTicket">View Renew Ticket</v-button>
                <v-button
                  v-if="showViewRenewBtn&&renew_ticket_id<=0"
                  green
                  icon="eye"
                  @click="viewRenewQuote">View Renew Quote</v-button>

                <!--                <v-button-->
                <!--                  v-if="detailData.renew_status !== 7&&renew_ticket_id>=0"-->
                <!--                  red-->
                <!--                  @click="handleVoidTicket">Void Ticket</v-button>-->
                <!--                <v-button-->
                <!--                  v-if="[2,3].includes(detailData.renew_status)"-->
                <!--                  warning-btn-->
                <!--                  @click="changeNoNeedRenew(0)">No Need Renew</v-button>-->
                <!--                <v-button-->
                <!--                  v-if="[5].includes(detailData.renew_status)"-->
                <!--                  icon="turn-down"-->
                <!--                  @click="changeNoNeedRenew(1)">Back to Pending</v-button>-->
              </div>
              <template v-if="!isFina">
                <div
                  v-if="currentFormData.customer_id<=0"
                  class="box">
                  <div class="flex-sb">
                    <span class="title fs-14 fw-600 mg-b-10">Customer</span>
                  </div>
                  <span class="flex-align-center">
                    <i class="el-icon-user fs-16 fw-600 gray mg-r-8"></i>
                    <span class="fs-14 fw-600 gray">Without Account</span>
                  </span>
                </div>
                <right-customer-detail
                  :detail-data="currentFormData"
                  :only-share="currentFormData.customer_id<=0"
                  :show-customer="currentFormData.customer_id>0"
                  :customer-profile="currentFormData.customer"
                  is-policy
                  @view="viewCustomer"
                  @share="handlerShare"
                  @unShare="handleUnShare"
                  @editDes="editDescription"></right-customer-detail>
              </template>
              <edit-summary
                v-if="isSMEProduct"
                :inter-summary="currentFormData.inter_summary"
                :order-id="orderId"
                @update="handleUpdateDetail"></edit-summary>
              <template v-if="!isNewSME">
                <right-plan-info
                  :detail-data="currentFormData"
                  @view="viewPlan"></right-plan-info>
              </template>

              <right-remark
                is-policy
                :remark="remarkList"
                :pcy-id="currentFormData.pcy_id"></right-remark>
            </aside>
          </div>

        </section>

      </div>
      <div
        v-else-if="showKyc"
        class="other-body">
        <edit-kyc
          ref="edit-kyc"
          :hasEndorsNum="hasEndorsNum"
          :hasClaimNum="detailData.unsettled_claims && detailData.unsettled_claims.length > 0"
          :editType="3"
          :is-fina="isFina"
          :customerId="customerId"
          :form="renewKycDetail"
          :fromEdit="fromEdit"
          @update="handleUpdateDetail"
          @nextStep="nextStep"
          @reply-all="handlerSave"
          @cancel="cancelEdit"></edit-kyc>
      </div>
      <div
        v-else
        class="other-body">
        <section v-show="showAdjustPolicy">
          <adjust-policy
            :form="formData"
            :isAdjust="true"
            :remarkList="remarkList"
            @cancel="handlerAdjustCancel"
            @success="handlerAdjustDone"
            @handlerRefresh="handlerRefresh"
          />
        </section>
      </div>

      <to-top
        v-if="!showMain"
        :el='container'></to-top>
    </section>


    <!-- dialog -->
    <new-general-ticket
      ref="new-general-ticket"
      :customer="currentFormData.customer"
      :form="ticketParams" />
    <new-endorsement-ticket
      ref="new-endorsement-ticket"
      :orderId="currentOrderId"
      :customer="currentFormData.customer"
      :form="ticketParams" />
    <new-claim-ticket
      ref="new-claim-ticket"
      :orderId="currentOrderId"
      :form="ticketParams"
      :detail-data="detailData"
      :customer="currentFormData.customer"
      :customer-profile="customer_profile"
    />
    <create-cheque
      ref="create-cheque"
      :form="chequeParams"
      @done="handler().updatePolicyDetail(0)" />

    <plan-dialog
      ref="plan-dialog"
      :planInfo="quote_plan_info"
      @get-reference-quote="getReferenceQuote" />

    <!--    <void-policy-->
    <!--      ref="void-policy"-->
    <!--      :orderId="currentOrderId"-->
    <!--      @done="handlerVoidDone" />-->
    <set-void-quote
      ref="void-dialog"
      :orderId="orderId"
      :form="detailData"
      @setVoid="handlerVoidDone"
    >
    </set-void-quote>
    <attach-user
      ref="attach-user"
      :is-share="true"
      @shareUser="handleShareCustomerId"
    />
    <attach-user></attach-user>
    <endors-renew-tips
      ref="claim-tips"
      :cliams="detailData.unsettled_claims"
      @continue="tipsContinue"></endors-renew-tips>
    <endors-renew-tips
      ref="endors-tips"
      :endorseNumber="detailData.endorsement_ticket_number"
      :endorseOrderId="detailData.endorsement_order_id"
      is-endorsement
      @continue="tipsContinue"></endors-renew-tips>
    <endors-renew-tips
      ref="renew-tips"
      :stts="detailData.renew_stts"
      :renewOrderSn="renewOrderSn"
      @continue="tipsContinue"></endors-renew-tips>

    <edit-description
      ref="edit-description"
      :detailData="customer_profile"
      :customerId="customerId"
      @update="getUpdateAccountData"></edit-description>
    <edit-description
      ref="edit-share-description"
      :detailData="shareInfo"
      :customerId="shareInfo.id"
      @update="handleUpdateDetail"></edit-description>

    <send-email-sms
      ref="send-email-sms"
      :form="send_customer_data"
      :updateContent="true"
      @send="handlerSend"
      @skip="handlerSkip" />
    <new-renew-titcket-dialog
      v-model="showRenewTicket"
      :customer="currentFormData.customer"
      :form="ticketParams"></new-renew-titcket-dialog>
  </section>
</template>
<script>
import {mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinPolicyholderDetail from '@/mixins/policyholader-detail'
import PolicyTab from './components/policy-tab'
import PaymentRecord from './components/payment-record'
import TicketsTab from './components/tickets-tab'
import ApiLog from './components/api-log'
import TheCheques from './components/cheques'
import ClaimsTab from './components/claims-tab'
import QuotesTab from './components/quotes-tab'
import PolicyInvoice from './components/policy-invoice'
import DetailAside from './components/detail-aside'
import NewGeneralTicket from '@/views/tickets/dialogs/new-general-ticket'
import NewEndorsementTicket from '@/views/tickets/dialogs/new-endorsement-ticket'
import NewClaimTicket from '@/views/tickets/dialogs/new-claim-ticket'
import setVoidQuote from '@/views/components/set-void-quote'
import editKyc from '@/views/tickets/components/edit-refer-case'
import endorsRenewTips from '@/views/components/dialogs/endors-renew-tips'
import BlockWarning from '@/views/components/waring-list'
import EditDescription from '@/views/accounts/dialog/edit-description.vue'

import {
  addPolicyRemark,
  changeTag,
  getPolicyDetail,
  getPolicyDetailLog,
} from '@/api/policy'
import {
  orderCsSet,
  getQuoteDetail, getQuoteAllNew
} from '@/api/quote'
// import { addAccountRemark } from '@/api/account'
import {orderReminder,completeNewBusinessOrder, issueOrderCvr, orderTurnToNewPcy,setRenewStatus,getClientPolicyDetail} from '@/api/order'
import AdjustPolicy from './components/adjust-policy'
import CreateCheque from './components/dialog/create-cheque'
import PlanDialog from '@/views/quoting/dialogs/plan-dialog'
import detailLog from '@/views/components/log/detail-log'
import {getAccountDetail} from '@/api/account'
import {getSMEPolicyDetail, SMEQuickQuote,addSMERenewal} from '@api/sme'
import {getNewSMEQuoteDetail, newSMEPolicyDetail} from '@api/new_sme'
import {removeShareUserPolicy, shareUserPolicy} from '@/api/share'
import {voidRenewalTicket} from '@/api/renewal'
import AttachUser from '@/views/quoting/dialogs/attachCustomer'
import {productAPiPath} from '@/utils/smePath'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

import rightCustomerDetail from '@/views/components/right-customer-detail'
import rightPlanInfo from '@/views/components/right-plan-info'
import rightRemark from '@/views/components/right-remark'
import NewRenewTitcketDialog from '@/views/renew/components/new-renew-ticket-dialog'
import EditSummary from '@/views/sme/components/edit-summary'
export default {
  name: 'PolicyDetail',
  components: {
    NewRenewTitcketDialog,
    rightRemark,
    PolicyTab,
    PaymentRecord,
    TicketsTab,
    TheCheques,
    ClaimsTab,
    QuotesTab,
    PolicyInvoice,
    NewGeneralTicket,
    NewEndorsementTicket,
    NewClaimTicket,
    AdjustPolicy,
    CreateCheque,
    DetailAside,
    PlanDialog,
    setVoidQuote,
    detailLog,
    AttachUser,
    editKyc,
    endorsRenewTips,
    ApiLog,
    EditDescription,
    rightCustomerDetail,
    rightPlanInfo,
    BlockWarning,
    SendEmailSms,
    EditSummary
  },
  mixins: [MixinOptions,MixinPolicyholderDetail],
  data() {
    return {
      oldFormDataLock: -1,
      container: null,
      activeTab: 'Policy',
      policyUrl: '',
      tabList: [
        {
          name: 'Policy',
          label: 'Policy'
        },
        {
          name: 'Documents',
          label: 'Proof Documents'
        },
        {
          name: 'Payment',
          label: 'Payment Record'
        },
        {
          name: 'Invoice',
          label: 'Policy & Invoice'
        },
        {
          name: 'Tickets',
          label: 'Tickets'
        },
        {
          name: 'Claims',
          label: 'Claims'
        },
        {
          name: 'Quotes',
          label: 'Quotes',
        },
        {
          name: 'Cheques',
          label: 'Cheques'
        },
        {
          name: 'log',
          label: 'Log'
        },
        {
          name: 'ApiLog',
          label: 'Api Log'
        }
      ],
      filterTabList:[],
      detailData: {
        customer: {}
      },
      formData: {}, // 當前選中 policy 數據
      // assignee: '',
      remarkList: [],
      message: '',
      showMain: true,
      showKyc: false,
      showAdjustPolicy: false,
      showRenewTicket: false,
      currentOrderId: 0,
      currentFormData: {},
      pcyTimer: null,
      clearTime: 0,
      loading: false,
      errorCode: '',
      copyDetailData: null,
      orignal_cs:'',
      customer_profile:{},
      tabName:[],
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      logsData:[],
      tagArr:[],
      step: 1,
      needShowTips: true,
      targetName: '',
      fromEdit: false,
      quoteDetailData: {}
    }
  },
  computed: {
    send_customer_data(){
      let {customer_id,cust_typ,isrd_nm,contact_phone,mobile_no } = this.detailData||{}
      if(customer_id>0)
        return this.customer_profile
      return {
        cust_typ,
        isrd_nm,
        contact_phone,
        mobile_no
      }
    },
    isFina(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform==2
    },
    merchant_platform(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform
    },
    renewKycDetail(){
      let data = this.fromEdit?this.quoteDetailData : this.detailData
      return {...data,...this.policyholderDetail}
    },
    isNewSME(){
      let {sme_versions} = this.detailData||{}
      return sme_versions==3
    },
    customer_description(){
      let str = this.customer_profile.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    share_customer_description(){
      let str = this.shareInfo.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    productId() {
      let {product_id=11} =  this.$route.query||{}
      return product_id
    },
    SmeProduct(){
      return this.productId>=80
    },
    orderId() {
      return this.$route.query.id
    },
    pcyId() {
      return this.$route.query.pcy_id
    },
    // 區分保單狀態，是否為 adjustable
    isAdjust() {
      // return true
      return this.currentFormData.type === 50
    },
    showComplete() {
      const { type, stts } = this.currentFormData
      if(stts >= 420) {
        return false
      }
      return [10, 20, 50].includes(type)
    },
    showEndorsementTicketBtn() {
      if(this.isHaveCancelRecord) {
        return false
      }
      const { type, stts } = this.detailData
      return [10, 20, 30, 50].includes(type) && stts >= 420
    },
    showViewEndorsement() {
      const { pcy_stts } = this.detailData
      // return [501, 505, 510, 701, 705, 710].includes(pcy_stts)
      return [501, 505, 701, 705].includes(pcy_stts)
    },
    showRenewBtn(){
      const {renew_order_id, is_renewal_conditions} = this.detailData
      return !renew_order_id && is_renewal_conditions == 1
    },
    showRenewTag(){
      const {effective_quote} = this.detailData
      return effective_quote == 1
    },
    showViewRenewBtn(){
      const {renew_order_id, effective_quote,renew_status} = this.detailData
      return renew_order_id && [2,3].includes(renew_status)
    },
    renew_ticket_id(){
      const {renew_ticket_id=0} = this.detailData||{}
      return renew_ticket_id
    },
    showEditRenewBtn(){
      const {effective_quote} = this.detailData
      return effective_quote == 0
    },
    showClaimTicketBtn() {
      const { pcy_stts } = this.detailData
      return pcy_stts > 400
    },
    showVoidBtn() {
      const { adjust_void_policy_enable } = this.detailData
      // return [10, 20, 50].includes(type) && stts == 410
      return adjust_void_policy_enable==1
    },
    showChequeBtn() {
      return this.detailData.pcy_stts != 0
    },
    isSMEProduct(){
      return this.SmeProduct
    },
    showEndorsementStatusBar() {
      const { endorsement_quote_pending } = this.detailData
      if (!endorsement_quote_pending || !endorsement_quote_pending.id) {
        return false
      }
      return true
    },
    ticketParams() {
      const { contact_phone,cust_typ,cs_id,is_guest_order, customer_id,isrd_nm,type_of_insured, pcy_no,nm_traveler_list,nm_pa_list, quotation_number, pcy_id, mobile_no, phone_no,referrer } = this.currentFormData
      let {id} = referrer||{}
      let list = []
      if([14,18].includes(Number(this.productId))){
        list = Number(this.productId)==14?nm_traveler_list:nm_pa_list
      }
      return {
        assignee_id: cs_id,
        customer_id,
        policy_no: pcy_no,
        quote_no: quotation_number,
        pcy_id,
        contact_no: cust_typ==2?contact_phone:(mobile_no? mobile_no: phone_no),
        merchant_platform:this.merchant_platform,
        referrer_id:id||'',
        list,
        type_of_insured,
        is_guest_order,
        isrd_nm
      }
    },
    isHaveCancelRecord() {
      // 檢查 record 是否存在已完成的 cancel 單
      const { record = [] } = this.currentFormData
      if(!record || record.length < 1) {
        return false
      }
      let haveCancel = false
      record.some(item => {
        const { period_record = [] } = item
        period_record.some(inItem => {
          const { type, stts } = inItem
          if(type == 40 && stts >= 420) {
            haveCancel = true
            return true
          }
        })
        if(haveCancel) {
          return true
        }
      })
      return haveCancel
    },
    chequeParams() {
      const { customer, id, customer_id } = this.currentFormData
      return {
        isrd_nm: customer? customer.isrd_nm : '',
        order_id: this.isNewSME?this.orderId:id,
        customer_id
      }
    },
    pcyStts() {
      // const { stts } = this.detailData
      // return stts
      const { pcy_stts } = this.detailData
      return pcy_stts
    },
    newestOrderId() {
      const record = this.detailData.record || []
      if(record.length < 1) return false
      const { period_record = [] } = record[0]
      if(period_record && period_record.length > 0) {
        const len = period_record.length
        return period_record[len - 1].order_id
      }
      return record[0].order_id
    },
    isShowName(){
      let {customer,id_type} = this.currentFormData
      if(customer.isrd_nm)
        return customer.isrd_nm.trim()!=''
      else return  false
    },
    plan_info(){
      let {quote_coverage_list} = this.currentFormData||{}
      let {plan_info} =quote_coverage_list||{}
      return plan_info||{}
    },
    company_logo(){
      let {company_logo} = this.currentFormData||{}
      return this.isSMEProduct?company_logo:this.plan_info.company_logo
    },
    quote_plan_info(){
      if(this.isNewSME)
        return {}
      let {quote_coverage_list,sidebar_info} = this.currentFormData||{}
      return this.SmeProduct?sidebar_info:quote_coverage_list
    },
    shareInfo(){
      let {share_user_infos} = this.currentFormData
      return share_user_infos||{}
    },
    customerId() {
      return this.detailData.customer_id
    },
    hasEndorsNum(){
      return typeof this.detailData.endorsement_ticket_number == 'string' && this.detailData.endorsement_ticket_number != ''
    },
    renewOrderSn(){
      return this.detailData.renew_order_sn || ''
    },
    needLoading(){
      return this.$route.params.needLoading || false
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    isGuestTravel(){
      let {is_guest_order} = this.currentFormData||{}
      return is_guest_order==1
    },
    isHzmb(){
      let {class_id} = this.detailData||{}
      return class_id==15
    }
  },
  watch: {
    orderId: {
      handler(val, old) {
        if(old) {
          this.handler().initUpdatePolicyDetail()
        }
      }
    },
    // errorCode: {
    //   handler(code) {
    //     if(code == 4404) {
    //       this.loading = true
    //       console.log('timer start ===')
    //       this.pcyTimer = setInterval(() => {
    //         console.log('timer ===')
    //         // 如果 pcy stts 為 -1 則重新獲取數據
    //         this.handler().getProductData({
    //           hideLoading: true,
    //           hideMessage: true
    //         })
    //         // if((Date.now()/1000) - this.clearTime >= 10) {
    //         //   this.loading = false
    //         //   clearInterval(this.pcyTimer)
    //         // }
    //       }, 2000)
    //     }
    //     else {
    //       console.log('clear timer ===', val)
    //       this.loading = false
    //       clearInterval(this.pcyTimer)
    //     }
    //   }
    // },
    pcyStts: {
      handler(val) {
        if(val == -1) {
          this.loading = true
          this.pcyTimer = setInterval(() => {
            // 如果 pcy stts 為 -1 則重新獲取數據
            this.handler().getProductData({
              hideLoading: true
            }, true)

            if((Date.now()/1000) - this.clearTime >= 10) {
              this.loading = false
              clearInterval(this.pcyTimer)
            }
          }, 1000)
        }
        else {
          this.loading = false
          clearInterval(this.pcyTimer)
        }
      }
    },
    'currentFormData.customer_id':{
      immediate:true,
      handler(val){
        if(val){
          this.network().getAccountDetail({customer_id:val})
        }
      }
    },
    detailData: {
      immediate: true,
      handler(val){
        if(val.tag_language){
          this.tagArr = []
          val.tag_language.filter(item => {
            this.tagArr.push(item.id)
          })
        }
      }
    },
    'detailData.renew_quote_list.total':{
      immediate: true,
      handler(val){
        // renew_quote_list的total大于0才显示quote标签
        if(val > 0){
          this.filterTabList = JSON.parse(JSON.stringify(this.tabList))
        }else{
          this.filterTabList = this.tabList.filter(item => {
            return item.name != 'Quotes'
          })
        }
      }
    }
  },
  created() {
    this.handler().getProductData({
      hideLoading: true
    }, true)
    this.clearTime = Date.now()/1000

    const { tab = '' } = this.$route.query
    if (tab) {
      this.activeTab = this.$route.query.tab
    }
    this.setProductId(this.productId)
    this.network().getPolicyDetailLog()
  },
  mounted(){
    this.container = this.$refs['container'].parentElement
  },
  destroyed() {
    clearInterval(this.pcyTimer)
  },
  methods: {
    ...mapActions('common', ['setProductId','setCarClassId']),
    ...mapActions('quote', ['setAllQuote', 'setQuoteForm', 'setQuoteResult']),
    ...mapActions('account', ['setCustomerId', 'setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    ...mapActions('smeQuote', ['setSmeQuickForm','setEstimatedPremium']),
    handleVoidTicket(){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        isGreen:true,
        message: 'Confirm void this ticket and its linked quotation?'
      }).then(()=>{
        this.network().voidRenewalTicket()
      })
    },
    handlerSend(content){
      let params ={
        content:content
      }
      this.network().orderReminder(params)
    },
    handlerSkip(){

    },
    handleRemindSend(){
      this.$refs['send-email-sms'].changeDialog()
    },
    async  handleCopyPolicy(type){
      await  this.network().getClientPolicyDetail({to_customer_type:type})
      let textareaElement = document.createElement('textarea')
      textareaElement.setAttribute('readonly', 'readonly') // 防止弹出输入编辑
      textareaElement .value = this.policyUrl
      document.body.appendChild(textareaElement )
      textareaElement .select() //选中textarea元素，以备调用系统copy函数复制其中的内容。
      let isSuccess = document.execCommand('copy')
      this.$NewMessageBox({
        title: 'Copy Link',
        message: 'The link has been copied to your clipboard',
        confirmBtn:'Done',
        btnType:'success'
      })
    },
    getUpdateAccountData() {
      this.network().getAccountDetail({customer_id:this.customerId})
    },
    editDescription(name){
      this.$refs[name].changeDialog()
    },
    changeNoNeedRenew(type){
      let params= {
      }
      if(type==1){
        params= {
          back_pending:1
        }
      }
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Renew Status',
        confirmBtn:'Confirm',
        isGreen:false,
        message: `Are you sure you want to change the renew status to <strong>${type==1?'Pending':'No Need'}</strong> ?`
      }).then(() => {
        this.network().setRenewStatus(params)
      })

    },
    handleUnShare(){
      this.$ConfirmBox({
        message: 'Confirm don\'t share ?',
        cancelBtn:'No',
      }).then(() => {
        this.network().removeShareUserPolicy()
      })

    },
    handlerShare(){
      this.$refs['attach-user'].showAttachCustomer()
    },
    handleShareCustomerId(data){
      this.network().shareUserPolicy({share_user_id:data})
    },
    hanldeLoading(val){
      this.$emit('loading', val)
    },
    quoteCurrentChange(page){
      this.handler().getProductData({
        hideLoading: true,
        renew_quote_page: page
      })
    },
    cancelEdit() {
      this.showKyc = false
      this.showMain = true
      this.handler().initUpdatePolicyDetail()
    },
    handlerSave(){
      this.cancelEdit()
    },
    nextStep(step){
      this.step = step
      this.showTips()
    },
    handleChangeLog(){
      if(this.activeTab=='log')
        this.network().getPolicyDetailLog()
    },
    handTabName(data){
      this.tabName = data
    },
    selectAssignee(id) {
      id = id?id:0
      orderCsSet({
        order_id: this.orderId,
        cs_id: id,
      }).then(data=>{
        this.orignal_cs = id
        this.$message({
          type: 'success',
          message: 'Success'
        })
      }).catch(err=>{
        this.detailData.cs_id = this.orignal_cs
      })
      // this.network().setTicketCs({
      //   cs_id: id
      // })
    },
    handlerRefresh(){
      this.showMain = true
      this.showAdjustPolicy = false
      this.handler().initUpdatePolicyDetail()
    },
    viewCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.currentFormData.customer_id
        }
      })
    },
    viewShareCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.shareInfo.id
        }
      })
    },
    viewPlan() {
      this.$refs['plan-dialog'].changeDialog()
    },
    viewTicket() {
      const { endorsement_quote_pending } = this.currentFormData||{}
      const { id } = endorsement_quote_pending||{}
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: id
        }
      })
    },
    onViewEndorsementTicket() {
      const { ticket_id } = this.currentFormData
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id
        }
      })
    },
    getCurrentOrderId(id) {
      this.currentOrderId = id
    },
    getCurrentFormData(data) {
      this.currentFormData = data
    },
    updateTicketsData(data) {
      console.log('uuuuu')
      this.handler().getProductData(data)
      // if(this.productId == 12) {
      //   this.network().getHousemaidPolicyDetail(data)
      //   return
      // }
      // this.network().getPolicyDetail(data)
    },
    openDialog(target) {
      if(this.needShowTips && (target == 'new-endorsement-ticket' || target == 'new-claim-ticket')){
        // new endorsement ticket和new claim ticket判断是否需要弹窗
        this.targetName = target
        this.step = 4
        this.newTicketShowTips()
      }else{
        this.$refs[target].changeDialog()
        this.needShowTips = true
      }
    },
    handlerVoid(){
      this.handler().initUpdatePolicyDetail()
    },
    handlerVoidPolicy() {
      this.$refs['void-dialog'].changeDialog()
    },

    async addRenewQuote(){
      this.showRenewTicket = true
      // this.fromEdit = false
      // let newest = this.detailData.record[0]
      // const {period_record, pcy_id} = newest
      // const order_id = period_record[0].order_id
      // if(this.productId>=80&&this.isNewSME){
      //   await  this.network().addSMERenewal()
      //   return
      // }else
      //   await this.handler().getProductData({
      //     hideLoading: true,
      //     add_renew: 1,
      //     order_id,
      //     pcy_id
      //   })
      // if(this.hasEndorsNum || (this.detailData.unsettled_claims && this.detailData.unsettled_claims.length > 0)){
      //   this.showTips()
      //   this.step = 1
      //   return
      // }
      // this.showMain = false
      // this.showKyc = true
    },
    editRenewQuote(){
      this.fromEdit = true
      // 拿quote detail数据回填
      this.handler().getQuoteDetail()
      // 调用add_renew检查是否弹窗
      this.handler().getProductData({
        hideLoading: true,
        add_renew: 1
      })
      if(this.hasEndorsNum || (this.detailData.unsettled_claims && this.detailData.unsettled_claims.length > 0)){
        this.showTips()
        this.step = 1
        return
      }
      this.showMain = false
      this.showKyc = true
    },

    viewRenewQuote(){
      // this.showMain = false
      // this.showKyc = true
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: this.detailData.renew_order_id,
          product_id: this.productId
        }
      })
    },
    viewRenewTicket(){
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: this.renew_ticket_id,
        }
      })
    },

    // 開啓 adjust 流程
    handlerAdjustPolicy(data) {
      this.formData = {...data,...this.policyholderDetail} // 選中 policy 數據
      this.showMain = false
      this.showAdjustPolicy = true
    },
    handlerAdjustCancel() {
      this.showMain = true
      this.showAdjustPolicy = false
    },
    handlerAdjustDone(data) {
      const { order_id, stts, pcy_id } = data

      if(stts >= 401) {
        this.$router.replace({
          path: '/records/policy/detail',
          query: {
            id: order_id,
            pcy_id,
            product_id: this.productId
          }
        })
      }
      else {
        this.handler().initUpdatePolicyDetail()
      }
    },
    handlerVoidDone(data) {
      let {sme_versions} = this.$route.query||{}
      const { order_id, pcy_id } = data
      this.$router.replace({
        path: '/records/policy/detail',
        query: {
          id: order_id,
          pcy_id,
          product_id: this.productId,
          sme_versions
        }
      })
    },
    async  tipsContinue(isEndorsement=false,type){
      if((this.$refs['endors-tips'].dialog == false) && (this.$refs['claim-tips'].dialog == false) && (this.$refs['renew-tips'].dialog == false)){
        switch(this.step){
          case  1:
            // add renew quote
            let {endorsement_order_id}  = this.detailData||{}
            if(endorsement_order_id>0&&type==2)
            {
              await this.handler().getProductData({
                hideLoading: true,
                add_renew: 1,
                order_id:endorsement_order_id,
              })
            }
            this.showMain = false
            this.showKyc = true
            break
          case 2:
            // edit kyc -> next
            this.$refs['edit-kyc'].continueAndNext()
            break
          case 3:
            // edit kyc -> next -> reply all
            this.$refs['edit-kyc'].$refs['reply'].onReferralSendSms(1)
            break
          case 4:
            // new endorsement/claim ticket
            this.needShowTips = false
            this.openDialog(this.targetName)
        }
      }
    },
    async onCopyKyc() {
      await this.handler().getPolicyProductDetail(
        {
          pcy_id: this.pcyId,
          order_id: this.newestOrderId
        },
        false,
        true
      )
    },
    handleUpdateDetail(){
      this.handler().updatePolicyDetail({
        add_renew: 1
      })
    },
    handlerMarkIssuingSuccess() {
      this.handler().updatePolicyDetail()
      // send Email / SMS

    },
    showTips(){
      if(this.hasEndorsNum){
        this.$refs['endors-tips'].changeDialog()
      }
      if(this.detailData.unsettled_claims && this.detailData.unsettled_claims.length > 0){
        this.$refs['claim-tips'].changeDialog()
      }
    },
    newTicketShowTips(){
      // 针对 new endorsement ticket和new claim ticket判断是否需要弹窗
      if(this.renewOrderSn){
        this.$refs['renew-tips'].changeDialog()
      }else{
        this.needShowTips = false
        this.openDialog(this.targetName)
      }
    },
    getReferenceQuote(){
      if(this.currentFormData && this.currentFormData.policy_invoice && this.currentFormData.policy_invoice.record){
        // 获取当前的policy_invoice
        let item  = this.currentFormData.policy_invoice.record.find(subItem => {
          return subItem.id == this.orderId
        })
        if(item && item.data){
          const res = item.data.find(subItem => {
            return subItem.type == 'quotation_pdf_path'
          })
          if(res.file && res.file.url){
            window.open(res.file.url, '_blank')
          }
        }
      }
    },
    event() {
      return {
        onComplete: type => {
          if(type === 0) {
            this.network().issueOrderCvr()
          }
          else if(type === 1) {
            this.network().orderTurnToNewPcy()
          }
          else {
            this.network().completeNewBusinessOrder()
          }
        }
      }
    },
    handler() {
      return {

        initUpdatePolicyDetail: () => {
          this.showMain = true
          this.showAdjustPolicy = false
          this.handler().getProductData({
            hideLoading: true
          })
          // if(this.productId == 12) {
          //   this.network().getHousemaidPolicyDetail({
          //     hideLoading: true
          //   })
          //   return
          // }
          // this.network().getPolicyDetail({
          //   hideLoading: true
          // })
        },
        updatePolicyDetail: (params) => {
          this.handler().getProductData({
            ...params,
            hideLoading: true
          })
          // if(this.productId == 12) {
          //   this.network().getHousemaidPolicyDetail({
          //     hideLoading: true
          //   })
          //   return
          // }
          // this.network().getPolicyDetail({
          //   hideLoading: true
          // })
        },
        getProductData: async(params = {}, deep = false) => {
          let etraParams = {}
          // etraParams = this.pcyId?{pcy_id: this.pcyId}:{ order_id: this.orderId}
          etraParams = {
            pcy_id: this.pcyId? this.pcyId : null,
            order_id: this.orderId? this.orderId : null,
          }

          let result = {
            ...etraParams,
            ...params
          }
          // 輪詢
          if(deep) {
            result = {
              order_id: this.orderId,
              hideLoading: true
            }
          }

          // switch(Number(this.productId)) {
          //   case 11:
          //     this.network().getPolicyDetail(result, deep)
          //     break
          //   case 12:
          //     this.network().getHousemaidPolicyDetail(result, deep)
          //     break
          //   case 15:
          //     this.network().getInteriorPolicyDetail(result, deep)
          //     break
          //   case 17:
          //     this.network().getHomefirePolicyDetail(result, deep)
          //     break
          // }
          await  this.handler().getPolicyProductDetail(result, deep)
        },
        getPolicyProductDetail: async (result, deep, isCopy = false) => {
          if(this.needLoading){
            delete result.hideLoading
          }
          if(this.productId>=80)
          {
            // if(this.isNewSME)
            // {
            await this.network().newSMEPolicyDetail(result, deep, isCopy)
            return
            // }
            // await this.network().getSMEPolicyDetail(result, deep, isCopy)
            // return
          }
          await this.network().getPolicyDetail(result, deep, isCopy)
        },
        getQuoteDetail:async () =>{
          if(this.isSMEProduct){
            await this.network().getNewSMEQuoteDetail()
          }else 
            await this.network().getQuoteDetail()
        }
      }
    },
    network() {
      return {
        setTicketCs: async params => {
          const {data} = await orderCsSet({
            order_id: this.orderId,
            ...params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        changeTag: () => {
          let tag = this.tagArr.includes(1)? 2 : 1
          let params = {
            pcy_id: this.pcyId,
            tag_id: tag
          }
          changeTag(params).then(() => {
            this.handler().getPolicyProductDetail({
              pcy_id: this.pcyId,
              order_id: this.newestOrderId
            })
          })
        },
        getPolicyDetail: async (params = {}, deep, isCopy) => {

          const { data } = await getPolicyDetail({
            // ...etraParams,
            ...params
          },this.productId)
          // .catch(({ response }) => {
          //   const { data } = response
          //   const { code } = data || {}
          //   this.errorCode = code
          // })
          if(isCopy) {
            this.copyDetailData = data
            await this.network().getQuoteAllNew(this.copyDetailData)
            return
          }

          const { pcy_stts } = data
          if(pcy_stts != -1) {
            this.loading = false
            clearInterval(this.pcyTimer)
          }
          this.detailData = data
          this.orignal_cs = data.cs_id
          this.currentFormData = JSON.parse(JSON.stringify(data))
          // this.assignee = data.assignee
          if (data.remark_list) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark_list))
          }
          if(deep && pcy_stts != -1) {
            this.handler().getProductData({
              hideLoading: true
            })
          }else {
            this.oldFormDataLock += 1
          }
          // this.oldFormDataLock = 1
          // let {type } =data||{}

        },
        getSMEPolicyDetail: async (params = {}, deep, isCopy) => {
          let {data} = await getSMEPolicyDetail({
            ...params,
            order_id: this.orderId
          },this.classId)
          if(isCopy) {
            this.copyDetailData = data
            await this.network().getSMEQuickQuote(this.copyDetailData)
            return
          }

          const { pcy_stts } = data
          if(pcy_stts != -1) {
            this.loading = false
            clearInterval(this.pcyTimer)
          }

          this.detailData = data
          this.orignal_cs = data.cs_id
          this.currentFormData = JSON.parse(JSON.stringify(data))
          // this.assignee = data.assignee
          if (data.remark_list) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark_list))
          }
          if(deep && pcy_stts != -1) {
            this.handler().getProductData({
              hideLoading: true
            })
          }else {
            this.oldFormDataLock += 1
          }
        },
        addSMERenewal: async (params) => {
          let {data} = await addSMERenewal({
            ...params,
            order_id: this.orderId
          })
          let {order_id,ticket_id} = data||{}
          this.$router.push({
            path:'/sme/tickets/detail',
            query:{
              ticket_id
            }
          })
        },
        voidRenewalTicket: async (params) => {
          let {data} = await voidRenewalTicket({
            ticket_id: this.renew_ticket_id
          })
        },
        newSMEPolicyDetail: async (params = {}, deep, isCopy) => {
          let {data} = await newSMEPolicyDetail({
            ...params,
            order_id: this.orderId
          })
          // if(isCopy) {
          //   this.copyDetailData = data
          //   await this.network().getSMEQuickQuote(this.copyDetailData)
          //   return
          // }

          const { pcy_stts } = data
          if(pcy_stts != -1) {
            this.loading = false
            clearInterval(this.pcyTimer)
          }

          this.detailData = data
          this.orignal_cs = data.cs_id
          this.currentFormData = JSON.parse(JSON.stringify(data))
          // this.assignee = data.assignee
          if (data.remark_list) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark_list))
          }
          if(deep && pcy_stts != -1) {
            this.handler().getProductData({
              hideLoading: true
            })
          }else {
            this.oldFormDataLock += 1
          }
        },
        orderTurnToNewPcy: async () => {
          const { data } = await orderTurnToNewPcy({
            order_id: this.orderId
          })
          this.handler().initUpdatePolicyDetail()
        },
        issueOrderCvr: async () => {
          const { data } = await issueOrderCvr({
            order_id: this.orderId
          })
          this.handler().initUpdatePolicyDetail()
        },
        completeNewBusinessOrder: async () => {
          const { data } = await completeNewBusinessOrder({
            order_id: this.orderId
          })
          this.handler().initUpdatePolicyDetail()
        },
        getSMEQuickQuote:async (params)=>{
          let class_id = params.class_id
          let {data} = await SMEQuickQuote(params,class_id)
          let {is_enable_case,estimated_premium_str} = data
          this.setSmeQuickForm(params)
          this.setEstimatedPremium(estimated_premium_str)
          // is_enable_case 1： 有效，可以進行下一步操作 Buy Policy | Download
          //is_enable_case 0： 無效，可以進入 Add Refer Case Ticket 進入人工單流程
          let type = productAPiPath[class_id]
          this.setProductId(class_id)
          if(is_enable_case==1)
          {
            this.$router.push('/quoting/customer/sme')
          }
          else {
            this.$router.push(`/quoting/${type}/refer`)
          }
        },
        getQuoteAllNew: async (policyData) => {
          const currentDetailData = policyData? policyData: this.detailData
          // const { data } = await getQuoteAllNew(currentDetailData)

          this.setQuoteForm({
            ...currentDetailData,
            copy: 1 // 標記是 copy kyc
          })

          if(this.isFina){
            let {referrer={}} = currentDetailData||{}
            this.setReferCustomerId(referrer.agent_id)
            this.setSelectReferCustomerData(referrer)
          }else {
            this.setCustomerId(currentDetailData.customer_id)
            this.setSelectCustomerData(currentDetailData.customer)
          }
          this.setProductId(this.productId)
          this.setCarClassId(this.detailData.class_id)
          let serverType = this.isFina?'fina':'holdcover'
          if([13,21].includes(this.productId))
          {
            let { data } = await getQuoteAllNew(this.detailData)
            if(!data.list || data.list.length < 1) {
              this.$router.push({
                name: 'quotingRefer',
                query: {
                  product_id: this.productId
                }
              })
              return
            }
            this.setAllQuote(data.list)
            this.setQuoteResult(data)
            this.$router.push({
              path: `/quoting/${serverType}/quote`,
              query: {
                product_id: this.productId
              }
            })
          }else
            this.$router.push({
              path: `/quoting/${serverType}/underwriting`,
              query: {
                product_id: this.productId
              }
            })
        },
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
        },
        getPolicyDetailLog: async () => {
          const {data} = await getPolicyDetailLog({
            pcy_id:this.pcyId,
            page: this.pageConfig.currentPage,
          })
          this.logsData = data.data
        },
        shareUserPolicy: async (params) => {
          const {data} = await shareUserPolicy({
            pcy_id:this.pcyId,
            ...params
          })
          this.handler().updatePolicyDetail()
          this.handleChangeLog()
        },
        removeShareUserPolicy: async () => {
          const {data} = await removeShareUserPolicy({
            pcy_id:this.pcyId,
          })
          this.handler().updatePolicyDetail()
          this.handleChangeLog()
        },

        // quote detail
        getQuoteDetail: async (params) => {
          const {data} = await getQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          },this.productId)

          this.quoteDetailData = data
        },
        getNewSMEQuoteDetail: async (params) => {
          const {data} = await getNewSMEQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        getCarQuoteDetail: async (params) => {
          const {data} = await getCarQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })

          this.quoteDetailData = data
        },
        getHousemaidQuoteDetail: async (params) => {
          const {data} = await getHousemaidQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        getInteriorQuoteDetail: async (params) => {
          const {data} = await getInteriorQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        getHomefireQuoteDetail: async (params) => {
          const {data} = await getHomefireQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        getTravelQuoteDetail: async (params) => {
          const {data} = await getTravelQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        getStudentQuoteDetail: async (params) => {
          const {data} = await getStudentQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        getWorkingQuoteDetail: async (params) => {
          const {data} = await getWorkingQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        getPersonalQuoteDetail: async (params) => {
          const {data} = await getPersonalQuoteDetail({
            order_id: this.detailData.renew_order_id,
            ...params
          })
          this.quoteDetailData = data
        },
        orderReminder: async (params) => {
          const { data } = await orderReminder({
            order_id: this.orderId,
            ...params
          })
        },
        setRenewStatus: async (params) => {
          if(!this.pcyId)
            return
          const {data} = await setRenewStatus({
            pcy_id: this.pcyId,
            ...params
          })
          this.handler().initUpdatePolicyDetail()
        },
        getClientPolicyDetail: async (params) => {
          const {data} = await getClientPolicyDetail({
            order_id: this.orderId,
            ...params
          })
          this.policyUrl = data.url
        },
      }
    }
  }
}
</script>
<style lang="scss">
.detail-page-container {
  .el-loading-mask {
    .el-loading-spinner {
      top: 200px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../../../src/assets/css/pay-main-header';
.detail-page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  //padding: 20px;
  min-height: 100%;
  padding-bottom: 40px;
  box-sizing: content-box;
  .share-content{
    padding-bottom: 5px;
    .label{
     padding-bottom: 0;
    }
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .top-bar {
    padding-top: 5px;
    color: #409eff;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #409eff;
  }
  .main-container {
    //margin-top: 20px;
    .pdb-10{
      padding-bottom: 10px;
    }
    .main-header {
      padding: 15px 70px 0px 70px;
      border-bottom: 1px solid #D1D5DA;
      background-color: #FAFBFC;
      margin-bottom:20px;
      ::v-deep .el-tabs__header{
        margin-bottom: 0;
      }
      .margin-bottom{
        padding-bottom: 20px;
      }
      &.border_bottom{
        //padding: 20px 70px 0px 70px;
        border-bottom: 1px solid #D1D5DA;
        margin-bottom: 30px;
        padding-bottom: 30px;
      }
      .header-title {
        display: flex;
        padding-bottom: 15px;
        align-items: center;
        &.mg-b-5{
          padding-bottom: 5px;
        }
        .icon {
          font-size: 18px;
          &.gray {
            color: #586069;
          }
          &.green {
            color: #22863A;
          }
          &.red {
            color: #D73A49;
          }
        }
        h3 {
          padding-bottom: 0;
          padding: 0 15px;
          color: #24292E;
        }
        .hcid {
          display: inline-block;
          padding-right: 20px;
          font-size: 14px;
          color: #586069;
          font-weight: 500;
        }
      }

      .span-status, .span-options {
        display: inline-block;
        margin-right: 15px;
        padding: 5px 10px;
        border-radius: 12px;
        font-size: 12px;
        line-height: 14px;
        color: white;
        font-weight: 500;
        .svg-inline--fa {
          margin-right: 5px;
          font-size: 14px;
        }
      }
      .span-status {
        &.green {
          background: #28a745;
          color: white;
        }
        &.orange {
          background: #E36209;
          color: white;
        }
        &.yellow-dark {
          background: #DBAB09;
        }
        &.blue {
          background: #0366D6;
        }
        &.red {
          background: #d73a49;
        }
        &.min-green {
          background: #dcffe4;
          color: #28a745;
        }
      }
      .span-options{
        border: 1px solid;
        &.gray {
          border-color: #586069;
          color: #586069;
        }
        &.green {
          border-color: #22863A;
          color: #22863A;
        }
        &.yellow-dark {
          border-color: #DBAB09;
          color: #DBAB09;
        }
        &.red {
          border-color: #D73A49;
          color: #D73A49;
        }
        &.gold {
          border-color: #735C0F;
          color: #735C0F;
        }
        &.blue {
          border-color: #0366D6;
          color: #0366D6;
        }
        &.orange {
          border-color: #C24E00;
          color: #C24E00;
        }
        &.black {
          border-color: #24292E;
          color: #24292E;
        }
      }
      .header-date {
        padding-right: 15px;
        font-size: 14px;
        color: #586069;
        font-weight: 500;
      }
      .header-label {
        display: inline-block;
        padding-right: 15px;
        color: #586069;
        font-size: 14px;
        font-weight: 500;
      }
      .top {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        h1 {
          padding-bottom: 0;
        }
        .company-logo {
          margin-right: 15px;
          height: 42px;
          img {
            height: 42px;
          }
        }
      }
      .info-container {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        border-top: 1px solid #dddfe7;
        & > div {
          font-size: 14px;
          color: #91939a;
          & > span:first-child {
            display: block;
            padding-bottom: 5px;
            font-size: 14px;
            font-weight: bold;
            color: #616266;
          }
        }
      }
    }
    .main-body {
      padding: 0 70px;
      .main-content {
        flex: 1;
        display: flex;
        //margin-right: 15px;
        .middle-col {
          flex: 1;
          min-width: 600px;
        }
        .right-col {
          margin-left: 30px;
          //width: 280px;
        }
        .status-bar {
          margin-bottom: 15px;
          padding: 15px;
          align-items: center;
          border-radius: 4px;
        }
        .status-bar-endorsement {
          background: #e6a23d;
          .left {
            color: white;
            span {
              display: block;
              font-size: 14px;
              &:first-child {
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }
        .status-bar-blue {
          background: #e1efff;
          .left {
            color: #1d43a0;
            font-size: 14px;
            span:first-child {
              display: inline-block;
              padding-right: 15px;
              font-weight: bold;
            }
          }
        }
        .void-status {
          padding: 15px;
          background: #c81f1d;
          color: white;
          font-size: 14px;
          border-radius: 4px;
          span:first-child {
            display: inline-block;
            padding-right: 15px;
            font-weight: 500;
          }
        }
      }
      aside {
        width: 280px;
        .yellow-card {
          background: #FBCB15;
          .label {
            color: #723C14;
          }
          p {
            padding-bottom: 8px;
            color: #723C14;
            font-size: 14px;
          }
        }
        .remark-add {
          z-index: 2;
          margin: 0 -15px;
          padding: 15px 15px 0 15px;
          border-top: 1px solid #dddfe7;
        }
        .remarks-container {
          z-index: 1;
          max-height: 300px;
          overflow-y: auto;
          .remark-box {
            margin-bottom: 10px;
            font-size: 12px;
            color: #91939a;
            .remark-header {
              display: flex;
              justify-content: space-between;
              span:first-child {
                font-weight: bold;
              }
            }
            p {
              padding-bottom: 10px;
              color: #616266;
            }
          }
        }
        .plan-card {
          .flex {
            .logo {
              width: 80px;
              height: 45px;
              img {
                max-width: 80px;
                max-height: 45px;
              }
            }
            p {
              padding-left: 10px;
              font-size: 14px;
              line-height: 18px;
              font-weight: 500;
              color: #616266;
            }
          }
        }
        .rej{
          border-radius: 20px;
          color: #FFFFFF;
          background: #D73A49;
          padding: 0px 6px;
          width: 64px;
          height: 16px;
          margin: 0px 4px;
        }
      }
    }
    .other-body{
      padding: 0 70px;
    }
  }
  .number-color{
    color:#24292E ;
    //font-weight: 480;
  }
  .number-fontsize{
    font-size: 14px;
    font-weight: normal;
  }
  .purple {
    background: #6F42C1;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style: italic;
  }
  .name{
    color: #616266;
  }
  .card{
    ul {
      margin-top: 15px;
      li {
        display: flex;
        padding: 5px;
        list-style: none;
        color: #606266;
        font-size: 12px;
        line-height: 14px;
        span {
          flex: 1;
          .tag{
            .span-tag{
              display: inline-block;
              border-radius: 100px;
              height: 18px;
              background: #FFFFFF;
              padding: 0px 8px;
              font-weight: 600;
              font-size: 12px;
              line-height: 18px;
              box-sizing: content-box;
              white-space: nowrap;
              margin-bottom: 4px;
              &.verified{
                border: 1px solid #22863a;
                color: #22863a;
              }
              &.pending_verify{
                border: 1px solid #dbab09;
                color: #dbab09;
              }
              &.not_verify{
                border: 1px solid #d73a49;
                color: #d73a49;
              }
              &.unread-uplod{
                border: 1px solid #f66a0a;
                color: #c24e00;
              }
              &.professional-status, &.coupon-status, &.discount-status{
                border: 1px solid #0366d6;
                color: #0366d6;
              }
              &.green {
                background: #DCFFE4;
                color: #28A745;
                border: none;
              }
              &.orange {
                background-color:#FFF5B1 ;
                color:  #B08800;
                border: none;
              }
              &.red {
                background: #D73A49;
                color:#fff;
                border: none;
              }
            }
          }
        }

        span:first-child {
          font-weight: bold;
        }
      }
      li:first-child {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
      }
      li:last-child {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
      margin-bottom: 15px;
    }
  }
}
span.edit{
  color: #0366D6;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.description-content{
  font-weight: 400;
  font-size: 14px;
  color: #24292E;
  margin-bottom: 15px;
}
.box{
  padding: 29.5px 0;
  border-bottom: 1px solid #D1D5DA;
  .status{
    color: #68C23A
  }
}
.verified-color{
  color: #22863a;
}
.pending_verify-color{
  color: #dbab09;
}
/deep/.el-tabs--top{
  margin-top: 0px!important;
}
.table-icon{
  &.margin-top-flex{
    margin-top: 5px;
  }
  .icon{
    //margin-right: 10px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
  }
  .backgroud-width{
    background: #fff!important;
    border: 1px solid #e1e4e8;
  }
}
</style>
